<template>
	<b-nav-item-dropdown right no-caret>
		<template slot="button-content" v-if="$store.state.user">
			<avatar
				:username="$store.state.user.username"
				style="margin: 0 10px;"
				:size="40"
				:src="$store.state.user.avatar"
			></avatar>
		</template>
		<b-dropdown-header tag="div" class="text-center">
			<strong>{{ $t('languages') }}</strong>
		</b-dropdown-header>
		<b-dropdown-item
			v-for="l in locales"
			:key="l.code"
			@click="setLanguage(l)"
			:active="$root.locale === l.code"
		>
			<i class="fa fa-bell-o"></i>
			{{ l.name }}
		</b-dropdown-item>

		<b-dropdown-item @click="logout">
			<i class="fa fa-lock"></i>
			{{ $t('logout') }}
		</b-dropdown-item>
	</b-nav-item-dropdown>
</template>
<script>
	import {locales} from '../../config/i18n'
	import Cookies from 'js-cookie'
	import Avatar from 'vue-avatar'
	import axios from 'axios'

	export default {
		name: 'HeaderDropdown',
		components: {
			Avatar,
		},

		data: () => {
			return {
				itemsCount: 42,
				locales,
			}
		},
		methods: {
			setLanguage(lang) {
				this.$root.locale = lang.code
			},

			logout() {
				axios.post('/passport/logout').then(() => {
					localStorage.removeItem('token')
					this.$router.push('/user/login')
				})
			},
		},
	}
</script>
